import RequestStatus from "./RequestStatus";
import DateTime from "../core/DateTime";
import SearchRequest from "../models/SearchRequest";
import Hospital from "../models/Hospital";
import DateFormat from "./DateFormat";

export default class DateUtils {
  public constructor() {}
  public static getCompletedRequest(
    hospitals: Array<SearchRequest>
  ): Array<Hospital> {
    let hps: Array<Hospital> = [];

    for (let sr of hospitals) {
      if (sr.status === RequestStatus.Resolved) {
        hps.add(sr.hospital);
      }
    }

    return hps;
  }
  public static format(dateTime: DateTime): string {
    if (dateTime === null) {
      return "";
    } else {
      return new DateFormat("dd MMM yyyy hh:mm a EEE").format(dateTime);
    }
  }
}
